import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import "./dashboard-component.scss";
import { Doughnut } from "react-chartjs-2";
ChartJS.register(ArcElement, Tooltip, Legend);

const DonutChart = ({ barChartData }) => {
  const data = {
    labels: barChartData?.status,
    datasets: [
      {
        labels: barChartData?.status,
        data: barChartData?.values,
        label: "Percent",
        backgroundColor: [
          "#2a9d8f",
          "#0ea5e9",
          "#d97706",
          "#e11d48",
          "#6366f1",
          "#7c3aed",
        ],
        borderColor: "#fff",
        borderWidth: 2,
      },
    ],
  };

  const chartOptions = {
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
    },
    cutout: "75%",
  };
  return (
    <div className="order-status-chart">
      <Doughnut data={data} options={chartOptions} />
    </div>
  );
};

export default DonutChart;
